






































































// Vue
import { Component, Vue } from 'vue-property-decorator'

// vuex
import { mapGetters } from 'vuex'
import { namespace } from 'vuex-class'

// models
import { MenuModel, SubMenuModel, UserLogin } from '@/models'

// constants
import { menuHorizontalItems } from '@/constants'
import { BIconCalendarEvent } from 'bootstrap-vue'

const layout = namespace('layout')

@Component({
    name: 'HorizontalNavBar',
    computed: {
      ...mapGetters('auth', {
        auth: 'auth'
      })
    }
})
export default class HorizontalNavBar extends Vue {
    menuItems!: MenuModel[]
    auth!: UserLogin

    created () {
        this.menuItems = menuHorizontalItems
    }

    mounted () {
        const links = document.getElementsByClassName('side-nav-link-ref')
        let matchingMenuItem: any = null
        for (let i = 0; i < links.length; i++) {
            // @ts-ignore
            if (window.location.pathname === links[i].pathname) {
                matchingMenuItem = links[i]
                break
            }
        }
        if (matchingMenuItem) {
            matchingMenuItem.classList.add('active')
            const parent = matchingMenuItem.parentElement

            /**
             * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
             * We should come up with non hard coded approach
             */
            if (parent) {
                parent.classList.add('active')
                const parent2 = parent.parentElement
                if (parent2) {
                    parent2.classList.add('active')
                }
                const parent3 = parent2 ? parent2.parentElement : null
                if (parent3) {
                    parent3.classList.add('active')
                    const childAnchor = parent3.querySelector('.has-dropdown')
                    if (childAnchor) { childAnchor.classList.add('active') }
                }

                const parent4 = parent3 ? parent3.parentElement : null
                if (parent4) { parent4.classList.add('active') }
                const parent5 = parent4 ? parent4.parentElement : null
                if (parent5) { parent5.classList.add('active') }
            }
        }
    }

    // methods
    @layout.Action
    public changeLayoutType !: (layoutType: string) => void

    /**
     * Menu clicked show the submenu
     */
    onMenuClick (event: Event | BIconCalendarEvent) {
      event.preventDefault()
      const nextEl = (event.target) ? event.target.nextSibling : null
      if (nextEl && !nextEl.classList.contains('show')) {
        const parentEl = event.target.parentNode
        if (parentEl) {
          parentEl.classList.remove('show')
        }
        nextEl.classList.add('show')
      } else if (nextEl) {
        nextEl.classList.remove('show')
      }
      return false
    }

    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems (item: MenuModel) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false
    }

    changeLayout (layout: string) {
      return this.changeLayoutType(layout)
    }

    topbarLight () {
      document.body.setAttribute('layoutType: string', 'layoutType: string')
      document.body.removeAttribute('layoutType: string')
    }

    boxedWidth () {
      document.body.setAttribute('layoutType: string', 'boxed')
      document.body.removeAttribute('layoutType: string')
      document.body.setAttribute('layoutType: string', 'dark')
    }

    ativeSubItem (route_name: string, subItems: SubMenuModel[]): boolean {
      let isActive = false
      subItems.forEach(item => {
        if (item.name === route_name) {
          isActive = true
        }
      })
      return isActive
    }

    isCan (roles: number[]): boolean {
      if (roles.length === 0) {
        return true
      }
      const roleIdAuth = Number(this.auth.role_id)
      if (roles.find(rId => rId === roleIdAuth)) {
        return true
      }
      return false
    }
}
